export default [
  {
    path: 'forgot-password',
    name: 'forgot-password',
    component: () => import('./ForgotPasswordPage.vue')
  }
]
